import { CheckCircleOutlineOutlined, ContentCopyOutlined } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';

import BaseOutlinedInput from '@/components/shared/Form/BaseOutlinedInput';
import theme from '@/theme';

interface FinishGenerateApiKeyStepProps {
  publicKey: string;
  secretKey: string;
  isPublicKeyCopied: boolean;
  onPublicKeyCopy: () => void;
  isSecretKeyCopied: boolean;
  onSecretKeyCopy: () => void;
}

function FinishGenerateApiKeyStep({
  publicKey,
  secretKey,
  isPublicKeyCopied,
  onPublicKeyCopy,
  isSecretKeyCopied,
  onSecretKeyCopy,
}: FinishGenerateApiKeyStepProps) {
  return (
    <>
      <Typography sx={{ ...theme.hhglobal.typography.body.large }}>
        Your new API key has been created. Copy the secret key now — it won't be shown again.
      </Typography>
      <BaseOutlinedInput
        id='public-key-id'
        name='public-key-name'
        inputLabel='Public key'
        value={publicKey}
        isDisabled
        isFullWidth
        size='small'
        type='text'
        errorMessage={null}
        helperIcon={
          <IconButton aria-label='copy-public-key' onClick={onPublicKeyCopy}>
            {isPublicKeyCopied ? <CheckCircleOutlineOutlined /> : <ContentCopyOutlined />}
          </IconButton>
        }
      />
      <BaseOutlinedInput
        id='secret-key-id'
        name='secret-key-name'
        inputLabel='Secret key'
        size='small'
        value={secretKey}
        isDisabled
        isFullWidth
        type='text'
        errorMessage={null}
        helperIcon={
          <IconButton aria-label='copy-secret-key' onClick={onSecretKeyCopy}>
            {isSecretKeyCopied ? <CheckCircleOutlineOutlined /> : <ContentCopyOutlined />}
          </IconButton>
        }
      />
    </>
  );
}

export default FinishGenerateApiKeyStep;
